<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
          <v-row justify="center" class="mt-10">
            <v-col cols="12" md="12" xs="12">
              <v-row justify="center">
                <v-col cols="12" sm="8" xs="12">
                  <v-card style="border: 0" outlined elevation="0">
                    <v-card-title class="justify-center">
                      Política de Privacidad y Tratamiento de datos Personales
                    </v-card-title>
                    <v-card-text>
                      <div class="text--primary">
                        Los Datos Personales que serán objeto de tratamiento por parte de DINO TOYS serán almacenados en el banco de datos de titularidad de DINO TOYS. DINO TOYS declara que cualquier tratamiento de los Datos Personales se ajusta en las normativas de protección de datos personales vigentes y aplicables dentro del territorio peruano.<br><br>
                        1. INFORMACIÓN SOBRE EL TRATAMIENTO OBLIGATORIO DE DATOS PERSONALES:<br>
                        Tiendas DINO TOYS informa al cliente que, para la prestación de los servicios y/o ejecución de las disposiciones establecidas en los Términos y Condiciones aceptados, realizará el tratamiento de su nombre, apellidos, No. de documento de identidad, dirección, correo electrónico, contraseña y/o teléfono mientras dure la relación contractual. Este tratamiento será realizado por DINO TOYS de forma directa y/o a través de sus proveedores, así como otras empresas encargadas del procesamiento y almacenamiento de datos.<br><br>

                        DINO TOYS cumple con informarle al cliente que la información mencionada en el párrafo precedente es necesaria para el cumplimiento de las obligaciones a su cargo, las mismas que de otra forma no podrían ejecutarse. Entre los servicios y/o disposiciones mencionados se encuentran: i) la creación y gestión de cuenta de usuario, ii) la coordinación, entrega de productos y postventa (medición de satisfacción, registro de vales/cupones).<br><br>
                        2. FINALIDADES ADICIONALES DE TRATAMIENTO:<br>
                        Con la aceptación de la presente Política de Privacidad el cliente otorga su consentimiento para que los Datos Personales sean tratados por un plazo indefinido, y mientras no solicite su cancelación o revoque la presente autorización, para las siguientes finalidades adicionales:<br><br>

                        a. Enviar al cliente información comercial, promocional y/o publicidad con relación a los productos y/o servicios brindados por DINO TOYS, así como realizar prospección comercial. El contacto podrá realizarse a través de los siguientes medios: centros de llamada (call centers), sistemas de llamado telefónico, envío de mensajes de texto a celular o de mensajes electrónicos masivos y telemercadeo.<br>
                        b. Almacenar y tratar los Datos Personales con fines estadísticos y/o históricos.
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'

  export default {
    name: 'PrivacyPolicy',
    components: {
      DefaultLayout
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/PrivacyPolicy.vue